import { Components } from "@mui/material/styles";
import { AiOutlineCaretRight } from 'react-icons/ai';
import * as React from 'react';

export const MuiBreadcrumbs: Components['MuiBreadcrumbs'] = {
    defaultProps: {
        separator: <AiOutlineCaretRight style={{ fontSize: '8px' }} />
    },
    styleOverrides: {
        root: {
            '& .MuiLink-root': {
                cursor: 'pointer',
                fontWeight: 400,
                color: '#0090D1',
                textDecoration: 'none!important'
            },
            '& :not(.MuiLink-root)': {
                color: '#005075',
                fontStyle: 'bold',
                fontWeight: 700
            },
            '& svg': {
                color: '#0090D1',
            }
        }
    }
};
